export default function (currentUser, getVehicle, $element, $compile, sendLetterContent, $scope, $injector, getNextLetter, getLetterByReference, getScannedLetter, skipLetter) {
    const vm = this;

    vm.currentUser = null;

    currentUser()
        .then(result => {
            vm.currentUser = result;
            setTemplates();
        });

    vm.model = {};
    vm.templates = {};
    vm.templateTranslation = {};
    vm.selectedTemplate = null;
    vm.letterIsLoading = false;
    vm.searchByVrm = false;
    vm.keeperInformationIsLoading = false;
    vm.reference = '';
    vm.nextAvailableReference = '';
    vm.unableToRetrieveData = false;
    vm.unableToRetrieveLetterImage = false;
    vm.dataErrorMessage = '';
    vm.unableToLocateReferenceOrVrm = false;
    vm.imagedata = null;
    vm.imagetype = null;
    vm.scannedLetterId = null;
    vm.referenceNotFound = false;

    /* --- */

    vm.complete = complete;
    vm.setTemplates = setTemplates;
    vm.completeAndGoToNext = completeAndGoToNext;
    vm.onTemplateSelect = onTemplateSelect;
    vm.loadNextLetter = loadNextLetter;
    vm.loadLetterByReference = loadLetterByReference;
    vm.onKeeperChange = onKeeperChange;
    vm.clear = clear;
    vm.skip = skip;

    /* - watcher - */

    $scope.$watch(() => vm.templates, () => setTemplates(), true);
    $scope.$watch(() => vm.templateTranslation, () => setTemplates(), true);
    /* --- */

    /* --- */

    const contentEl = $element.find('content-area');

    /* --- */
    function setTemplates() {
        if (vm.currentUser.isRrd) {
            vm.templates = {
                ['last keeper signed']: {
                    template: require('../../../../common/letterTemplates/last-keeper-signed/last-keeper-signed.html')
                },
                ['previous keeper']: {
                    template: require('../../../../common/letterTemplates/previous-keeper/previous-keeper.html')
                },
                ['barcode not found']: {
                    template: require('../../../../common/letterTemplates/barcode-not-found/barcode-not-found.html')
                }
            };

            vm.templateTranslation = {
                LastKeeperSignedLetter: 'last keeper signed',
                PreviousKeeperLetter: 'previous keeper',
                BarcodeNotFound: 'barcode not found'
            };
        } else {
            vm.templates = {
                default: {
                    template: require('../../../../common/letterTemplates/default.html')
                },
                ['last keeper signed']: {
                    template: require('../../../../common/letterTemplates/last-keeper-signed/last-keeper-signed.html'),
                    getModel: require('../../../../common/letterTemplates/last-keeper-signed/getLastKeeperSignedModel')
                },
                ['dvla hard copy']: {
                    template: require('../../../../common/letterTemplates/dvla-hard-copy/dvla-hard-copy.html')
                },
                ['previous keeper']: {
                    template: require('../../../../common/letterTemplates/previous-keeper/previous-keeper.html')
                },
                ['barcode not found']: {
                    template: require('../../../../common/letterTemplates/barcode-not-found/barcode-not-found.html')
                }
            };

            vm.templateTranslation = {
                // AllDvLetter: 'dvla hard copy',
                SingleDvLetter: 'dvla hard copy',
                LastKeeperSignedLetter: 'last keeper signed',
                PreviousKeeperLetter: 'previous keeper',
                BarcodeNotFound: 'barcode not found'
            };
        }

        vm.templateNames = Object.keys(vm.templates);
    }

    function complete() {
        const viewModel = {
            keeper: vm.model,
            template: getKeyFromValue(vm.templateTranslation, vm.selectedTemplate),
            reference: vm.reference,
            scannedLetterId: vm.scannedLetterId
        };

        return sendLetterContent(viewModel)
            .then(() => {
                clear();
            });
    }

    function completeAndGoToNext() {
        complete().then(() => loadNextLetter());
    }

    function skip() {
        const viewModel = {
            scannedLetterId: vm.scannedLetterId
        };

        return skipLetter(viewModel)
            .then(() => {
                clear();
            });
    }

    function clear() {
        vm.model = {};
        vm.reference = '';
        vm.nextAvailableReference = '';
        vm.imagedata = null;
        vm.imagetype = null;
        vm.keepers = [];
        vm.scannedLetterId = null;

        contentEl.empty();
    }

    function onTemplateSelect() {
        vm.model = {};
        changeTemplate(vm.selectedTemplate);
    }

    function onKeeperChange() {
        vm.model = vm.selectedKeeper;
    }

    function changeTemplate(templateName) {
        const compiledContent = $compile(vm.templates[templateName].template)($scope);

        contentEl.empty();
        contentEl.append(compiledContent);
    }

    function loadLetterByReference() {
        vm.keeperInformationIsLoading = true;
        vm.showActions = false;

        getLetterByReference(vm.reference)
            .then(response => {
                handleLetterSetup(response);
                if (response !== null) {
                    vm.searchByVrm = response.searchByVrm;
                    vm.referenceNotFound = false;
                }
                vm.keeperInformationIsLoading = false;

                // return getScannedLetter(vm.reference);
            })
            .catch(() => {
                vm.keeperInformationIsLoading = false;
            });
    }

    function loadNextLetter() {
        toggleBlockers(true);
        vm.showActions = false;

        return getNextLetter()
            .then(response => {
                handleLetterSetup(response);

                return getScannedLetter(vm.reference || vm.nextAvailableReference);
            })
            .then(response => {
                if (response != null) {
                    vm.imagedata = response.imageBase64Encoded;
                    vm.imagetype = response.imageContentType;
                    vm.scannedLetterId = response.scannedLetterId;
                }

                vm.letterIsLoading = false;
            })
            .catch(() => {
                toggleBlockers(false);

                vm.letterIsLoading = false;
            });
    }

    function handleLetterSetup(response) {
        if (response) {
            vm.hasLetterData = true;
            const templateKey = vm.templateTranslation[response.letterType];
            changeTemplate(templateKey);

            const letterType = 'PreviousKeeperLetter';

            if (response.letterType !== letterType) {
                vm.model = response.targetKeeper;
            }

            vm.nextAvailableReference = response.referenceCodeOrVrm;
            vm.reference = response.referenceCodeOrVrm;
            vm.selectedTemplate = templateKey;

            if (templateKey === 'barcode not found') {
                vm.reference = '';
                vm.referenceNotFound = true;
            }

            if (response.keepers) {
                vm.keepers = response.keepers;
            }

            if (response.rrdKeepers) {
                vm.keepers = response.rrdKeepers;
            }
        }

        toggleBlockers(false);
    }

    function toggleBlockers(on) {
        vm.letterIsLoading = on;
        vm.keeperInformationIsLoading = on;
    }

    function getKeyFromValue(obj, value) {
        const key = Object.keys(obj).filter(e => {
            if (!obj.hasOwnProperty(e)) {
                return false;
            }

            if (obj[e] === value) {
                return true;
            }
        })[0];

        return key;
    }
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/controllers/letters/compose/composeLetterCtrl.js